/** Normaliza un string para comparar (acentos/caso/espacios/simbolos), unificando variantes
 *  equivalentes entre el wording del backend y el de la UI (ej. "1era infancia" vs "primera infancia"). */
export function normalizeForCompare(s: string): string {
  return (s || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\blgbtiq\+?\b/g, 'lgbtq')
    .replace(/\b1era\b|\b1ra\b/g, 'primera')
    .replace(/\bjunguiana\b/g, 'junguiano')
    .replace(/[^a-z0-9/+]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}
